export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-600">有任何问题或建议？欢迎与我们取得联系</p>
        </div>
        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="p-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-600">business@fanqieys.com</p>
            </div>
            <div className="p-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-customer-service-2-line text-xl"></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-600">content@fanqieys.com</p>
            </div>
            <div className="p-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-200 text-secondary-700 mx-auto mb-3">
                <i className="ri-question-answer-line text-xl"></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-600">support@fanqieys.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}